export default __webpack_public_path__ + "static/media/ISOWhite.f1a5101c.svg";